
import { defineStore } from "pinia";
import { ref } from "vue";
import { getUserInfo, login, UserInfo } from '../../api/common'
import { removeToken, setToken } from "../../api";
import { pinia } from '..'
import { routesStore } from '@/store/router'
import router from '@/router'

export const userStore = defineStore('user', () => {

  const _routerStore = routesStore()

  const userInfo = ref<Partial<UserInfo>>({})
  const permissions = ref<string[]>([])
  const roles = ref<string[]>([])
  const tenantName = ref('')
  const getUser = async () => {
    const res = await getUserInfo()
    permissions.value = res.permissions
    roles.value = res.roles
    userInfo.value = res.user
    tenantName.value = res.tenantName
  }


  const userLogin = async (username: string, password: string, tenantId: string) => {
    const res = await login({
      username: username,
      password: password,
      tenantId: tenantId
    })
    setToken(res.token)
    await getUser()
    // router.push('/')

  }

  /** 登出 */
  const logout = () => {
    removeToken()
    _routerStore.removeRoutes?.map((x) => {
      x()
    })
    _routerStore.removeRoutes = []
    userInfo.value = {}
    roles.value = []
    router.push('/login')
  }

  return {
    userInfo,
    permissions,
    roles,
    getUser,
    userLogin,
    logout,
    tenantName
  }
})

export const useUserStore = () => {
  return userStore(pinia)
}

